export const UPSELL_REPLACEMENT_SUBSCRIPTION_ID = "9999999999";